<template>
  <div class="formInfo">
    <div class="formInfo__header">
      <h1>{{ $t('partners.info.title') }}</h1>
    </div>

    <div
      class="formInfo__table"
      role="table"
      aria-label="contact info"
    >
      <div
        class="formInfo__row"
        role="row"
      >
        <div
          class="formInfo__cell formInfo__cell--label"
          role="cell"
        >
          {{ $t('partners.info.phone.title') }}
        </div>
        <div
          class="formInfo__cell formInfo__cell--value"
          role="cell"
        >
          {{ $t('partners.info.phone.text') }}
        </div>
      </div>

      <div
        class="formInfo__row"
        role="row"
      >
        <div
          class="formInfo__cell formInfo__cell--label"
          role="cell"
        >
          {{ $t('partners.info.email.title') }}
        </div>
        
        <div
          class="formInfo__cell formInfo__cell--value"
          role="cell"
          v-html=" $t('partners.info.email.text')"
        />
      </div>

      <div
        class="formInfo__row"
        role="row"
      >
        <div
          class="formInfo__cell formInfo__cell--label"
          role="cell"
        >
          {{ $t('partners.info.hours.title') }}
        </div>

        <div
          class="formInfo__cell formInfo__cell--value"
          role="cell"
        >
          {{ $t('partners.info.hours.text') }}
        </div>
      </div>
    </div>

    <div class="formInfo__description">
      <p>{{ $t('partners.info.description') }}</p>
    </div>

    <img
      src="/images/partners/partners.png"
      alt="partners"
      title="partners"
    >

    <div class="formInfo__copyright">
      <p class="formInfo__copyright__title">
        {{ $t('partners.info.copyright.title') }}
      </p>

      <p class="formInfo__copyright__address">
        {{ $t('partners.info.copyright.address') }}
      </p>

      <p
        class="formInfo__copyright__copy"
        v-html="$t('partners.info.copyright.copy')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.formInfo {
  display: flex;
  flex-direction: column;
  gap: 3.2rem;

  &__header {
    @include h11;
    color: $text-500;
  }

  &__table {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: $gray-100;
  }

  &__row {
    display: grid;
    grid-template-columns: 65px auto;
  }

  &__cell {
    display: flex;
    align-items: center;
    min-height: 4.8rem;
    margin-bottom: 0.8rem;
    padding: 1.2rem 0;

    &--label {
      @include body-2-medium;
      justify-content: flex-start;
      color: $text-400;
      text-align: right;
      border-bottom: 1px solid $gray-400;
    }

    &--value {
      @include body-2-medium;
      padding-right: 1.2rem;
      padding-left: 1.2rem;
      color: $text-500;
      overflow-wrap: anywhere;
      border-bottom: 1px solid $gray-400;
      border-left: 1px solid $gray-400;
    }
  }

  &__description {
    @include body-4;
    color: $text-200;
  }

  &__copyright {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;

    &__title {
      @include body-3-medium;
      color: $text-500;
    }

    &__address,
    &__copy {
      @include body-2;
      color: $text-300;
    }
  }

  @include atL {
    &__table {
      max-width: 35rem;
    }
  }
}
</style>
